import {combineReducers} from 'redux'
import menuReducer from './menu'

// for props.user
export default combineReducers({
    menu: menuReducer
});
